export default "__VITE_ASSET__8c1c4765__"